import * as q from 'qs';
import { regHistoryPlugin, Options } from './index';

export interface Obj {
  [key: string]: any;
}

const qsOptions = { ignoreQueryPrefix: true };

regHistoryPlugin('createLocation', (options: Options) => {
  const { currentLocation, location } = options;
  const currentQuery = q.parse(currentLocation?.search || '', qsOptions);
  const query = q.parse(location?.search || '', qsOptions);
  let mergeQuery: Obj = {};
  Object.keys(currentQuery).forEach(k => {
    if (/^wea_link_keep_/.test(k)) {
      mergeQuery[k] = currentQuery[k];
    }
  })
  mergeQuery = { ...mergeQuery, ...query };
  location.search = Object.keys(mergeQuery).length ? `?${q.stringify(mergeQuery)}` : '';
  return {
    currentLocation,
    location,
  }
})